import React from 'react';

export default function Plane(props) {
  return (
    <svg width='24' height='24' viewBox='0 0 32 32' {...props}>
      <g fill='currentColor'>
        <path d='M16.224 5.67c.096.05.175.128.223.224L18 9l-.14 2.905L26 17.5l.319 1.5-8.778-1.7-.114 1.566-.117 1.428-.08.875-.08.815-.083.753L20 24.76V26l-3.298-.738-.042.21-.084.38C16.392 26.618 16.2 27 16 27c-.286 0-.547-.573-.783-1.719l-3.217.72V24.76l2.841-1.959-.077-.697-.075-.75-.036-.396-.071-.83-.07-.884-.098-1.427-.032-.502L5.652 19 6 17.5l8.11-5.574-.084-2.17L14 9l1.553-3.106c.123-.247.424-.347.67-.223z' />
      </g>
    </svg>
  );
}
